import odata from "@/core/api/mixin/odata";
import rest from "@/core/api/mixin/rest";
import { apiClient } from "@/core/api/httpClient";
import moment from "moment";
import Utils from "@/core/utils/utils";

export default {
  ...odata("pricing-level-group"),
  ...rest("pricing-level-group"),

  getById: function (id, payload) {
    return apiClient.get(`pricing-level-group/${id}`, {
      params: {
        relations: "pricingLevels,createdByUser",
      },
    });
  },
  getReport: function (params) {
    let queryParams = {};
    if (params.$filter) {
      queryParams.$filter = params.$filter;
    }
    queryParams.$expand =
      "billingReportDetails,organization,businessGroup,billingInfo($expand=pricingLevelGroup)";
    return apiClient.get(`billing-report`, {
      params: queryParams,
    });
  },
  reportDetail: function (param) {
    const queryParams = {};
    queryParams.$filter = this.getFilterParam(param);

    queryParams.$expand =
      "billingReportDetails,organization,businessGroup,billingInfo($expand=pricingLevelGroup($expand=pricingLevels))";
    return apiClient.get(`billing-report`, {
      params: queryParams,
    });
  },
  reportPdf: function (param) {
    const queryParams = {};
    queryParams.$filter = this.getFilterParam(param);
    queryParams.$expand =
      "billingReportDetails,organization,businessGroup,billingInfo($expand=pricingLevelGroup($expand=pricingLevels))";
    return apiClient.get(`billing-report/download`, {
      params: queryParams,
      responseType: 'arraybuffer',
      headers: {
        'Accept': 'application/pdf'
      }
    });
  },
  getFilterParam: function ({ orgId, date }) {
    const momentDate = moment(date, "YYYY-MM").startOf("month");
    const endDate = moment(Utils.addMonth(momentDate.toDate(), 1)).format(
      "YYYY-MM-DD"
    );
    return `organization_id eq ${orgId} and startBillDate ge ${momentDate.format(
      "YYYY-MM-DD"
    )} and endBillDate lt ${endDate}`;
  },
};
